/** Japanese Entrepreneurship Support Translations */
export const entrepreneurship = {
  entrepreneurship: {
    pageTitle: "起業支援次元",
    weightInFII: "FIIでの重み",
    heroSubtitle: "若者が持続可能な雇用を創出し富を築く力を与える（18〜40歳）",
    quote: "1.7兆ドルは中小企業向けのグローバルな資金調達ギャップです。しかし、サハラ以南アフリカでは、28%の若者が積極的に起業を追求しています—世界平均の2.3倍。ギャップは野心ではありません。アクセスです。",
    fiiWeightDistribution: "FII重み配分",
    mentalHealth: "メンタルヘルス",
    workforceLabel: "労働力",
    entrepreneurshipLabel: "起業",
    understandOpportunity: "機会を理解する",
    opportunityTitle: "数字で見る起業機会",
    opportunitySubtitle: "グローバル青年起業を形作る重要な統計",
    opportunity: {
      stat1Label: "グローバル中小企業資金調達ギャップ",
      stat2Label: "サハラ以南アフリカの青年TEA率（世界平均の2.3倍）",
      stat3Label: "グローバル平均起業志向",
      stat4Label: "女性起業家へのVC資金",
      stat5Label: "世界的に女性への総VC資金",
      stat6Label: "年間新規スタートアップ立ち上げ数",
      stat7Label: "5年以内のスタートアップ失敗率",
      stat8Label: "起業1%増加あたりの雇用創出",
    },
    severity: {
      barrier: "障壁",
      opportunity: "機会",
      gap: "ギャップ",
    },
    coreProblem: "核心的問題",
    coreProblemDesc: "野心の不足ではありません。起業は伝統的雇用が限られた経済における主要な生存メカニズムです。アフリカ/中東では、52%の若者がビジネスを始めたいと思っています—それは贅沢ではなく、未来の経済です。真の障壁：資本ギャップ（世界で1.7兆ドル）、スキルギャップ（事業計画、金融リテラシー）、信頼ギャップ（貸し手は若い起業家を信頼しない）、インフラギャップ（規制負担、決済システム）、ジェンダーギャップ（女性は2〜3倍の追加障壁に直面）。",
    fiiTitle: "FII起業方法論",
    fiiSubtitle: "起業スコア = 未来インパクト指数の25%",
    subWeight: "サブウェイト",
    globalAverage: "グローバル平均",
    highest: "最高",
    lowest: "最低",
    fii: {
      easeOfBusiness: "ビジネスのしやすさ",
      easeOfBusinessDef: "規制環境、スタートアップの摩擦、事業登録",
      easeHighest: "シンガポール、ニュージーランド（90+）",
      easeLowest: "ベネズエラ、ソマリア（40-）",
      accessFinancing: "資金調達へのアクセス",
      accessFinancingDef: "資本の利用可能性、クレジットアクセス、VC、エンジェル資金",
      accessHighest: "米国、英国（人口の80%以上）",
      accessLowest: "サハラ以南アフリカ（10-20%）",
      tea: "初期段階起業（TEA）",
      teaDef: "新しいビジネスを積極的に開始/運営している人口の%",
      teaHighest: "サハラ以南アフリカ（28%）",
      teaLowest: "ヨーロッパ（12%）",
      digitalInfra: "デジタルインフラ",
      digitalInfraDef: "インターネット、決済システム、Eコマース準備",
      digitalHighest: "北欧諸国（95%）",
      digitalLowest: "サハラ以南アフリカ（20-30%）",
    },
    regionalTitle: "地域別起業スコア",
    regionalSubtitle: "FII起業次元：地域パフォーマンス",
    regions: {
      europe: "ヨーロッパ",
      asiaPacific: "アジアと太平洋",
      americas: "アメリカ",
      africaMe: "アフリカ・中東",
    },
    status: {
      strong: "強い",
      growing: "成長中",
      mixed: "混合",
      emerging: "新興",
    },
    regional: {
      europeDrivers: "規制支援、資本アクセス、インキュベーター",
      europeOpportunity: "リスク回避文化はイノベーション加速が必要",
      asiaPacificDrivers: "ユニコーンエコシステム、政府支援、テックハブ",
      asiaPacificOpportunity: "Tier-2/3都市は資本アクセスが必要",
      americasDrivers: "北米は強い（80+）、イノベーション文化",
      americasOpportunity: "ラテンアメリカは資本の民主化が必要",
      africaMeDrivers: "最高の志向（52%）、デジタルリープフロッグ",
      africaMeOpportunity: "深刻な資本ギャップの解消、MFI連携",
    },
    strength: "強み",
    challenge: "機会",
    easeScore: "容易さスコア",
    financingScore: "資金調達",
    teaScore: "TEA率",
    digitalScore: "デジタル",
    keyFinding: "重要な発見",
    keyFindingDesc: "起業スコアは12ポイントしか変動しない（ヨーロッパ72 vs アフリカ/中東60）—これはFIIギャップで最小。しかし、起業志向はアフリカ/中東で最高（52% vs グローバル35%）。つまり、能力は存在し、インフラだけが欠けている。",
    projectionTitle: "2024年 vs 2040年予測",
    financingTitle: "1.7兆ドルの資金調達ギャップ",
    financingSubtitle: "グローバル中小企業資金調達ギャップの発生源とJCIの支援方法",
    gapByRegion: "地域別資金調達ギャップ",
    trillion: "兆",
    totalGap: "グローバル中小企業資金調達ギャップ総額",
    timeline: "タイムライン",
    impact: "インパクト",
    financingGapTitle: "1.7兆ドルの資金調達ギャップ",
    financingGapSubtitle: "グローバル中小企業資金調達ギャップの発生源",
    financingGap: {
      subSaharan: "サハラ以南アフリカ",
      subSaharanGap: "5000億ドル以上",
      subSaharanCause: "正式な信用インフラなし、高リスク認識",
      southAsia: "南アジア",
      southAsiaGap: "4000億ドル以上",
      southAsiaCause: "規制障壁、非公式経済の支配",
      southeastAsia: "東南アジア",
      southeastAsiaGap: "2000億ドル以上",
      southeastAsiaCause: "規制の不一致、VC集中",
      latinAmerica: "ラテンアメリカ",
      latinAmericaGap: "3000億ドル以上",
      latinAmericaCause: "経済的変動性、規制負担",
      mena: "中東/北アフリカ",
      menaGap: "2000億ドル以上",
      menaCause: "資本市場の制限、ジェンダー差別",
    },
    gapMeaning: "「資金調達ギャップ」の本当の意味",
    gapTypes: {
      awareness: "認識ギャップ",
      awarenessDef: "起業家は資金調達源が存在することを知らない",
      access: "アクセスギャップ",
      accessDef: "資本は地理的＋人口統計的に集中",
      skills: "スキルギャップ",
      skillsDef: "提案書や財務予測を書けない",
      trust: "信頼ギャップ",
      trustDef: "貸し手は若い起業家を信頼しない",
      collateral: "担保ギャップ",
      collateralDef: "貧しい若者には担保にする資産がない",
      gender: "ジェンダーギャップ",
      genderDef: "女性は2〜3倍高い制度的障壁に直面",
    },
    landscapeTitle: "グローバル起業ランドスケープ",
    landscapeSubtitle: "地域別起業メトリクス（GEM 2024-25）",
    teaRate: "TEA率",
    businessTypes: "ビジネスタイプ",
    financing: "資金調達",
    successRate: "成功率",
    landscape: {
      subSaharanTitle: "サハラ以南アフリカ",
      subSaharanTea: "28% TEA（世界最高）",
      subSaharanTypes: "70%マイクロ、25%中小、5%スケーラブル",
      subSaharanFinancing: "80%自己/家族資金；5%正式",
      subSaharanSuccess: "40%生存率",
      southeastAsiaTitle: "東南アジア",
      southeastAsiaTea: "20% TEA（強い、成長中）",
      southeastAsiaTypes: "40%デジタル、35%小売、25%製造",
      southeastAsiaFinancing: "50%ブートストラップ、30%エンジェル/VC",
      southeastAsiaSuccess: "55%生存率",
      latinAmericaTitle: "ラテンアメリカ",
      latinAmericaTea: "18% TEA（成長中）",
      latinAmericaTypes: "60%マイクロ、30%中小、10%スケーラブル",
      latinAmericaFinancing: "70%自己資金、20%家族",
      latinAmericaSuccess: "45%生存率",
      europeTitle: "ヨーロッパ",
      europeTea: "12% TEA（成熟、安定）",
      europeTypes: "20%マイクロ、30%中小、50%スケーラブル",
      europeFinancing: "60%機関、40%自己資金",
      europeSuccess: "65%生存率",
      northAmericaTitle: "北米",
      northAmericaTea: "15% TEA（イノベーション主導）",
      northAmericaTypes: "10%マイクロ、20%中小、70%スケーラブル",
      northAmericaFinancing: "50% VC/エンジェル、30%機関",
      northAmericaSuccess: "70%生存率",
    },
    deepDiveTitle: "地域詳細分析",
    deepDiveSubtitle: "JCI地域別起業詳細分析",
    strengths: "強み",
    challenges: "課題",
    jciOpportunity: "JCI機会",
    deepDive: {
      europe: {
        strength1: "世界クラスのインフラ（規制の明確さ、デジタルシステム）",
        strength2: "資本アクセス：2024年に800億ユーロ以上投資",
        strength3: "成熟したスタートアップエコシステム：インキュベーター、アクセラレーター",
        challenge1: "リスク回避：失敗がスティグマ化",
        challenge2: "米国/アジアへの頭脳流出",
        challenge3: "ロンドン、ベルリン、パリへの資本集中",
        opportunity: "イノベーション加速、ディープテックスタートアップに注力",
      },
      asiaPacific: {
        strength1: "ユニコーンエコシステム：中国200+、インド80+",
        strength2: "政府加速：数十億投資",
        strength3: "人口配当：35%が25歳未満",
        challenge1: "極端な不平等：Tier-1都市に富が集中",
        challenge2: "規制の変動性",
        challenge3: "ジェンダー障壁：文化的＋制度的",
        opportunity: "Tier-2/3スタートアップイニシアチブ、女性テックプログラム",
      },
      americas: {
        strength1: "最大のVC市場（2024年に1500億ドル以上投資）",
        strength2: "イノベーション文化：シリコンバレー、NYC、トロント",
        strength3: "多様な市場：テック、バイオテック、フィンテック",
        challenge1: "14ポイントの南北格差",
        challenge2: "ラテンアメリカの規制負担",
        challenge3: "LAスタートアップの2%のみがVCを獲得",
        opportunity: "南北メンター連携の橋渡し、LAC能力",
      },
      africaMe: {
        strength1: "世界最高の志向：52%がビジネスを望む",
        strength2: "若い人口：60%が25歳未満",
        strength3: "デジタルリープフロッグ：モバイルファースト（95%以上が電話を持つ）",
        challenge1: "巨大な資金調達ギャップ：80%自己資金",
        challenge2: "スキルギャップ：事業計画、会計",
        challenge3: "女性が体系的に排除",
        opportunity: "10兆ドルの機会：12億人の若者の5%にリーチ→600万雇用",
      },
    },
    outcomesTitle: "成果とケーススタディ",
    outcomesSubtitle: "JCI CYE＆起業プログラムからの測定可能なインパクト",
    cases: {
      hongKongCountry: "香港",
      hongKongTitle: "JAPJAP Zero Waste Limited",
      hongKongOutcome: "食品廃棄物→AI-IoT技術を使用したタンパク質＋堆肥。女性創業者、移民背景。",
      hongKongMetric: "100トン以上処理",
      panamaCountry: "パナマ",
      panamaTitle: "Integra Project Management",
      panamaOutcome: "ラテンアメリカ向け食品サプライチェーン効率化。30の新製品、97%品質率。",
      panamaMetric: "250トンCO2削減",
      turkeyCountry: "トルコ",
      turkeyTitle: "Grinove Materials",
      turkeyOutcome: "農業廃棄物→コンポスタブルバイオマテリアル。科学者から起業家になった女性。",
      turkeyMetric: "欧州展開予定",
    },
    actionsTitle: "JCIへの推奨アクション",
    actionsSubtitle: "起業ギャップを埋めるための戦略的優先事項",
    actions: {
      action1Title: "CYEを10倍に拡大",
      action1Desc: "108から年間1,000人の起業家に拡大、2030年までに5,000人に到達",
      action1Effort: "18-24ヶ月",
      action1Impact: "10倍のリーチ",
      action2Title: "女性起業ファンド",
      action2Desc: "マイクロファイナンス＋メンタリングで女性創業者向け1億ドルファンド創設",
      action2Effort: "18ヶ月",
      action2Impact: "2030年までに5万人の女性",
      action3Title: "MFIパートナーシップ",
      action3Desc: "50のマイクロファイナンス機関とのパートナーシップを正式化",
      action3Effort: "12ヶ月",
      action3Impact: "50万人のクレジットアクセス",
      action4Title: "JCIインキュベーションハブ",
      action4Desc: "アフリカ/アジア/LACに30のインキュベーションハブを構築",
      action4Effort: "24ヶ月",
      action4Impact: "1万人をアクセラレート",
      action5Title: "スタートアップマーケットプレイス",
      action5Desc: "起業家をサプライヤー、顧客、メンターと繋ぐデジタルプラットフォーム作成",
      action5Effort: "9-12ヶ月",
      action5Impact: "10万人以上を接続",
      action6Title: "JIB地域ネットワーク",
      action6Desc: "5,000人以上のメンターと創業者を繋ぐメンターシップネットワーク構築",
      action6Effort: "12ヶ月",
      action6Impact: "5千人以上のメンター",
    },
    ctaTitle: "起業は雇用を創出する",
    ctaDescription: "伝統的な雇用が不足しているとき、起業は機会への主要な道筋となります。1人の起業家は3-5の雇用を創出します。JCIが2030年までに10倍に拡大すれば：500万の雇用創出、世界で5000億ドル以上のビジネス価値。",
    exploreFII: "FIIを探索",
    exploreWorkforce: "労働力を探索",
    dataSources: { title: "データソース" },
  },
} as const;

export type EntrepreneurshipTranslations = typeof entrepreneurship;
